module.exports = "pegasus/assets/pexels-photo-3.png";